import React, { useContext } from 'react';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { ConfigContext } from 'Context/config';

import { Content } from 'LegacySBCRA/Content/Content';

import LocalTexts from './BrandingContentTexts.json';

import styles from './BrandingContent.scss';

const texts = LocalTexts.default;
const LocalT = new MDText(texts);

const BrandingContent = () => {
  const { configState: { brandData } } = useContext(ConfigContext);
  const { main } = brandData?.brandContent || {};

  const renderContent = () => {
    if (main) {
      return <div dangerouslySetInnerHTML={{ __html: main }} className={styles.main} />;
    }

    return (
      <>
        <h3>{LocalT.translate('title')}</h3>
        <p>{LocalT.translate('topCopy')}</p>
        <ul>
          {texts.points.map((_, index) => (
            <li key={`points.${index}`}>
              {LocalT.translate(`points.${index}`)}
            </li>
          ))}
        </ul>
        <p>{LocalT.translate('bottomCopy')}</p>
      </>
    );
  };

  return (
    <Content
      className={cx(styles.component, { [styles.manufacturer]: main })}
      element="section"
    >
      <div className={cx(styles.content)}>
        {renderContent()}
      </div>
    </Content>
  );
};

export default BrandingContent;
